export default "__VITE_ASSET__bca2537d__"